module.exports = __webpack_public_path__ + "img/hr-tree-05-b-leaves.0574760e.png";